<script setup lang="ts">
import type { TextBlock } from '../../../model/assessments/interfaces'
import type { ContentBlockOwner } from '../../../model/assessments/store/interfaces'

import { useContentBlockText } from '../../../model/assessments/content-block-editors.hook'
import AnnotatedTextarea from './AnnotatedTextarea.vue'

defineOptions({
  name: 'ContentBlockText',
})

const props = defineProps<{
  owner: ContentBlockOwner
  index: number
  block: TextBlock
}>()

const { setValue } = useContentBlockText({
  owner: () => props.owner,
  index: () => props.index,
})
</script>

<template>
  <div class="content-block-text">
    <!-- No markers: a plain text block declares no gaps. `fill_in_blanks` and `drag_the_words`
         (T11) mount the same component with `markers` set.

         No label either — the card's own header already says this is a text block — and no
         audio URL: a text block that also plays audio is what the separate audio block is for.
         `TextBlock.audioUrl` stays in the schema and in the media manifest, so a stored block
         that has one keeps it and still uploads its file (decision B9). -->
    <AnnotatedTextarea
      :value="block.value"
      placeholder="Text shown on the screen"
      @update:value="setValue"
    />
  </div>
</template>

<style scoped lang="scss" src="./ContentBlockText.scss" />
